import React from 'react'
import { string } from 'prop-types'

function Banner({ title, subtitle, image }) {
  return (
    <div
      className="banner-container"
      style={{ backgroundImage: `url('${image}')` }}
    >
      <h2 className="banner-title cgt-legacy-heading-h2">{title}</h2>

      <h4 className="banner-subtitle cgt-legacy-heading-h4">
        {subtitle}
      </h4>
    </div>
  )
}

Banner.propTypes = {
  title: string.isRequired,
  subtitle: string.isRequired,
  image: string.isRequired,
}

export default Banner
